import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

export const IconInfo = styled.span`
  margin: 0 auto 0 4px;
  cursor: pointer;
  height: 16px;
`;

export const ModalContent = styled.p`
  width: 250px;
  margin: 50px 30px 30px;
  font-family: ${FONTS.OPEN_SANS};
`;
